import { useState, useEffect } from 'react'
import { Sidebar, RightHeader } from '..'
import { Layout } from 'antd'
import './Dashboard.scss'
import PropTypes from 'prop-types'

const { Sider, Content } = Layout

const MOBILE_LAYOUT_MQ = '(max-width: 767px)'

const getIsMobileLayout = () =>
	typeof window !== 'undefined' &&
	window.matchMedia(MOBILE_LAYOUT_MQ).matches

export const DashboardCommon = ({ children }) => {
	const [sideBarCollapse, setSideBarCollapse] = useState(getIsMobileLayout)
	const [isMobileLayout, setIsMobileLayout] = useState(getIsMobileLayout)

	useEffect(() => {
		const mq = window.matchMedia(MOBILE_LAYOUT_MQ)
		const handleChange = () => setIsMobileLayout(mq.matches)
		mq.addEventListener('change', handleChange)
		return () => mq.removeEventListener('change', handleChange)
	}, [])

	const toogleSidebar = () => setSideBarCollapse(!sideBarCollapse)

	return (
		<Layout className="dashboard">
			<Sider
				width="250px"
				collapsed={sideBarCollapse}
				collapsedWidth={isMobileLayout ? 0 : undefined}
			>
				<Sidebar />
			</Sider>
			<Layout>
				<RightHeader
					isSidebarCollapsed={sideBarCollapse}
					toogleSidebar={toogleSidebar}
				/>
				<Content>
					<div className="content">{children}</div>
				</Content>
			</Layout>
		</Layout>
	)
}

DashboardCommon.propTypes = {
	children: PropTypes.node,
}
